import { defineComponent as _defineComponent } from 'vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePostsStore } from '@@/pinia/surface_posts'
import SurfaceHeader from '@@/vuecomponents/SurfaceHeader.vue'
import SurfacePostsGridMasonry from '@@/vuecomponents/SurfacePostsGridMasonry.vue'
import { storeToRefs } from 'pinia'
import type { Id } from 'types'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceContainerGridMasonry',
  props: {
    reactionIdsByPostId: { default: () => ({}) },
    commentIdsByPostId: { default: () => ({}) }
  },
  emits: ['scroll'],
  setup(__props: any) {





const { xHeader, backgroundLuminance, isReadOnly, isScreenshotMode } = storeToRefs(useSurfaceStore())
const { allSortedPosts } = storeToRefs(useSurfacePostsStore())

const wallContainer = ref<HTMLDivElement>()

return { __sfc: true,xHeader, backgroundLuminance, isReadOnly, isScreenshotMode, allSortedPosts, wallContainer, SurfaceHeader, SurfacePostsGridMasonry }
}

})